import React, { useState } from "react";
import PropTypes from "prop-types";

import copy from "assets/icons/Copy.svg";

export default function CopyToClipboard({ textToCopy }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      //console.error('Unable to copy text: ', err);
    }
  };

  return (
    <div>
      <div className="share-modal-link-container">
        <div className="share-modal-link-text">{textToCopy}</div>

        <button className="share-modal-link-btn" onClick={copyToClipboard}>
          <img src={copy} />
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
    </div>
  );
}

CopyToClipboard.propTypes = {
  textToCopy: PropTypes.string.isRequired,
};
